import React, { useState } from 'react';
import { Badge, Button } from 'antd';
import { BellOutlined } from '@ant-design/icons';
import { useInAppNotifications } from '../hooks/useInAppNotifications';
import { NotificationDrawer } from './NotificationDrawer';

interface Props {
    className?: string;
}

export const NotificationBell: React.FC<Props> = ({ className }) => {
    const [drawerVisible, setDrawerVisible] = useState(false);
    const { stats, isLoading } = useInAppNotifications();

    return (
        <>
            <Badge count={stats?.unreadCount ?? 0} size="small" className={className}>
                <Button
                    type="text"
                    icon={<BellOutlined />}
                    onClick={() => setDrawerVisible(true)}
                    loading={isLoading}
                />
            </Badge>
            <NotificationDrawer visible={drawerVisible} onClose={() => setDrawerVisible(false)} />
        </>
    );
};
